import { View } from '../../../../../../base-components';
import { slotMargin } from '../../DateSelectorItem/DateSelector.constants';

const DaySpacer = () => {
  return <View style={{ width: slotMargin }} />;
};

export default DaySpacer;
